import React from "react";

const paragraphStyle = {
  marginTop: '1.5vh',
};

export type WarningAdditionalMessages = Record<number, JSX.Element>;

export const warningAdditionalMessages: WarningAdditionalMessages = {
  1000: (
    <p style={paragraphStyle}>
      A Chargebee subscription has not been created. Please create it manually.
    </p>
  ),
  1001: (
    <p style={paragraphStyle}>
      A Chargebee subscription has not been created. Please create it manually and change the customer's email to <strong>max.davies-long@splend.com</strong>.
    </p>
  ),
  1004: (
    <p style={paragraphStyle}>
      The Chargebee subscription was created successfully, but the invoice could not be collected.
      Please proceed to Chargebee to collect the payment manually or contact the customer about the payment issue.
    </p>
  ),

};
